/**
 * Created by Andrey on 21.10.2026.
 */

// Paid impressions of ads the game did not start, by the connector events alone: a farm plays rewarded and interstitial
// behind the game's back, so MAX reports <type>:impression without a <type>:start from the game. An impression is ours
// when it follows a start within WINDOW (a video runs about a minute, the paid callback may lag) and resets; any other
// one is a hit
class UnstartedAdsFraud extends cleverapps.EventEmitter {
    constructor() {
        super();

        this.config = {
            threshold: 3
        };

        this.startTime = {};

        for (const type of ["rewarded", "interstitial"]) {
            connector.ads.on(`${type}:start`, () => this.onStart(type));
            connector.ads.on(`${type}:impression`, () => this.onImpression(type));
        }
    }

    onStart(type) {
        this.startTime[type] = Date.now();
    }

    isStartedByGame(type) {
        const startTime = this.startTime[type];

        return startTime !== undefined && Date.now() - startTime <= cleverapps.parseInterval(UnstartedAdsFraud.WINDOW);
    }

    onImpression(type) {
        this.trigger(this.isStartedByGame(type) ? "reset" : "hit");
    }
}

UnstartedAdsFraud.WINDOW = "15 minutes";
